import { Navigate, Routes, Route } from "react-router-dom";
import { privateRoutes } from "router";
import OAuthService from "API/OAuthService";


function AppRouterPrivate({ children }) {
    const auth = true
    const userInfo = OAuthService.decryptedSync('userData')

    if (!auth) {
        return <Navigate to='/main' state={{ auth: true }} />
    }


    return (<Routes>
        {
            ((userInfo?.part?.id) || userInfo?.superUser === true) &&
            privateRoutes.map(rout => <Route path={rout.path} element={<rout.component />} key={rout.path} />)
        }
        <Route path="*" element={<Navigate to="/nofound" />} />
    </Routes>
    )
}

export default AppRouterPrivate;